import { createContext, useContext } from 'react';
import type { AdminProductScope } from '../lib/product-scope';

const ProductScopeContext = createContext<AdminProductScope>('platform');

export function ProductScopeProvider({
  scope,
  children,
}: {
  scope: AdminProductScope;
  children: React.ReactNode;
}) {
  return <ProductScopeContext.Provider value={scope}>{children}</ProductScopeContext.Provider>;
}

export function useProductScope(): AdminProductScope {
  return useContext(ProductScopeContext);
}
